import { isDemoAccountId } from '../modules/accountSelector/demoAccounts';

/**
 * Sent on every music24-api tRPC request while the demo artist (LaziiBee) is the active artist.
 * The procedures keyed by the workspace (Watchlist, Markets, reports, isFollowing) take no
 * artist, so this header tells them to answer the demo data. Keep it in step with
 * `DEMO_ARTIST_HEADER` in music24-api/src/app/components/DemoArtist/analytics/demoArtistHeader.ts.
 */
export const DEMO_ARTIST_HEADER = 'x-music24-demo-artist';

/** The extra request headers for the active account: the demo header for the demo artist, else none. */
export function demoArtistHeaders(accountId: number | null | undefined): Record<string, string> {
  return isDemoAccountId(accountId) ? { [DEMO_ARTIST_HEADER]: '1' } : {};
}

/**
 * The procedures whose answer depends on the demo header. Their cached answers belong to one
 * side (the workspace or the demo), so they are reset when the demo artist becomes active or
 * stops being active. Everything else keys its cache by the account id already.
 */
const DEMO_SCOPED_PROCEDURES = new Set([
  'artists.listFollowed',
  'artists.isFollowing',
  'tracks.listFollowed',
  'tracks.isFollowing',
  'playlists.listFollowed',
  'playlists.isFollowing',
  'playlists.combinedFollowersTimeSeries',
  'markets.topCountries',
  'markets.reachByService',
  'reports.getMyDailyReport',
  'reports.getMyWeeklyReport',
]);

/** True for a tRPC query key (`[['artists', 'listFollowed'], {...}]`) of a demo-scoped procedure. */
export function isDemoScopedQueryKey(queryKey: readonly unknown[]): boolean {
  const path = queryKey[0];
  if (!Array.isArray(path)) {
    return false;
  }
  return DEMO_SCOPED_PROCEDURES.has(path.join('.'));
}
